import { ConnectedPlayerVersionOptions } from "./connected-player-version-options";
import { ConnectedTagsOptions } from "./connected-tag-options";

const Provider = {
  TagOptions: ConnectedTagsOptions,
  PlayerVersionOptions: ConnectedPlayerVersionOptions,
};

export { Provider };
